import { Directive, ElementRef, Input } from '@angular/core';
import { ValueAndUnit } from '../models/misc.model';
import { BasicService } from '../services/basic.service';

@Directive({
  selector: '[appValueAndUnit]',
})
export class ValueAndUnitDirective {
  private vau: ValueAndUnit;
  private isShort: boolean;
  private isNoSpace: boolean;

  constructor(private elRef: ElementRef, private basicService: BasicService) {}

  @Input() set alcIsShort(isShort) {
    this.isShort = isShort;
    this.updateTextContent();
  }

  @Input() set alcIsNoSpace(isNoSpace) {
    this.isNoSpace = isNoSpace;
    this.updateTextContent();
  }

  @Input() set appValueAndUnit(vau: ValueAndUnit) {
    this.vau = vau;
    this.updateTextContent();
  }

  private updateTextContent() {
    let unitPrefix = this.vau.value > 1 ? 'm/unit/plural/' : 'm/unit/singular/';
    if (this.isShort) {
      unitPrefix = 'm/unit/short/';
    }
    const unitKey = unitPrefix + this.vau.unit;
    const spaceOrNot = this.isNoSpace ? '' : ' ';
    this.elRef.nativeElement.textContent = `${this.vau.value}${spaceOrNot}${this.basicService.translate(unitKey)}`;
  }
}
